export default "__VITE_ASSET__89d95a17__"